// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import styler from 'react-styling';
import { Button } from 'react-bootstrap/lib';

import AddGroupMemberMutation from '../Mutations/AddGroupMemberMutation';
import RemoveGroupMemberMutation from '../Mutations/RemoveGroupMemberMutation';
import { logError } from '../libs/Logger';

const style = styler `
    FavButtonIsFav
      color: #497BEB
      float: left

    FavContainer
      position: relative

    FavText
      float: left
      padding-top: 11px
      color: #666
      font-weight: 450
  `;

class Favourite extends Component {
  props: {
    language: Object,
    favourite: Object,
    selectedContactEmail: string,
    relay: Object,
  }
  _handleFavourite = () => {
    const favState = this.props.favourite.contact.isFavorite;
    if (favState) {
      this.props.relay.commitUpdate(
      new RemoveGroupMemberMutation({
        type: 'Contact',
        contacts: this.props.favourite,
      }),
        {
          onFailure: (error) => { logError(error); },
        }
    );
    } else {
      this.props.relay.commitUpdate(
      new AddGroupMemberMutation({
        type: 'Contact',
        contacts: this.props.favourite,
      }),
        {
          onFailure: (error) => { logError(error); },
        }
    );
    }
  }
  render() {
    return (
      <div style={style.FavContainer}>
        <p style={style.FavText}>{this.props.favourite.contact.isFavorite ? this.props.language.favorites_remove : this.props.language.favorites_add}</p>
        <Button
          style={this.props.favourite.contact.isFavorite ? style.FavButtonIsFav : null}
          bsStyle="link"
          title={this.props.language.favorites_add}
          onClick={this._handleFavourite}
        >
          <i className="fa fa-star fa-lg" />
        </Button>
      </div>
    );
  }
}


export default Relay.createContainer(Favourite, {
  initialVariables: {
    selectedContactEmail: null,
  },
  fragments: {
    favourite: () => Relay.QL`
      fragment on Viewer {
        contact(email: $selectedContactEmail) {
          id
          isFavorite
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/Favourite.js